import { render, staticRenderFns } from "./HighlightFighters.vue?vue&type=template&id=1ae18b0b&scoped=true&"
import script from "./HighlightFighters.vue?vue&type=script&lang=js&"
export * from "./HighlightFighters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae18b0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
